// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

//https://en.wikipedia.org/wiki/List_of_mobile_telephone_prefixes_by_country - list of phone number length

export const environment = {
  lang: 'ua',
  production: false,
  //gid: 39, //overwritten on ApiService->extractAccount
  //g_hash: '835f1369550e0cddaecaf687636653b6', //overwritten on ApiService->extractAccount
  logo_server: 'https://bufffit.com/',
  brandingTheme: 'lightgrey-darker-orange-red-theme',
  powered_by_company: 'Reserwill',
  powered_by_company_url: 'https://reserwill.com/',
  mobile_exit_strategy: 'viber',
  viber_url: 'viber://pa?chatURI=squashfitcenterlviv&context=',
  firstDayOfWeek: 1,
  phonePrefix: '+380',
  phone_length_min: 9,
  phone_length_max: 9,
  calendars: [{
    id: 0,
    duration: 2400,
    start: 28800,
    end: 84000,
  }],

};
